export const imgPath = (path?: string) =>
  `https://emtdad-eg.com/upload${path ? "/" + path : ""}`;
// `https://react.hanstarcarrental.com/public/upload${path ? "/" + path : ""}`;
// `https://egyptos-travel.com/public/upload${path ? "/" + path : ""}`;
